var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSeb(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 14,
    viewBox: "0 0 32 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "prefix__33976ec3-e47d-42c5-b6e7-6c35b39f1cc4",
    d: "M0 0.058L9.226 0.058 9.226 10.069 0 10.069z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__2fe5764f-a28f-4783-afdf-a1568383b6a6",
    d: "M0 14L31.905 14 31.905 0 0 0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 2)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "prefix__a2dcd628-58be-4cf6-8935-0efe409fd64c",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#prefix__33976ec3-e47d-42c5-b6e7-6c35b39f1cc4"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M0 8.133l1.82-1.358c1.273 1.108 2.164 1.268 2.907 1.268.849 0 1.645-.181 1.75-.663.08-.383-.238-.69-.965-.86C4.69 6.334 4 6.175 3.226 5.974 1.13 5.422.536 4.207.536 3.114.536 1.608 1.942.058 4.504.058c2.63 0 4.17 1.507 4.17 1.507l-1.72 1.284c-.81-.7-1.856-.833-2.434-.833-.583 0-1.194.164-1.29.584-.09.408.287.72.94.902.737.196 1.416.37 2.45.668 1.545.44 2.606 1.109 2.606 2.663 0 2.133-1.894 3.236-4.441 3.236C2.244 10.069.52 8.748 0 8.133",
    mask: "url(#prefix__a2dcd628-58be-4cf6-8935-0efe409fd64c)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "prefix__88d8afed-be18-45cd-8cc8-d3d3b418ed45",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#prefix__2fe5764f-a28f-4783-afdf-a1568383b6a6"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M9.989 14L10.583 14 10.583 0 9.989 0zM11.973 11.788L11.973 2.207 19.64 2.207 19.64 4.398 14.662 4.398 14.662 5.926 18.186 5.926 18.186 8.038 14.662 8.038 14.662 9.581 19.777 9.581 19.777 11.788zM20.785 14L21.379 14 21.379 0 20.785 0zM25.475 5.883h2.143c.499 0 .897-.393.897-.838 0-.45-.398-.844-.897-.844h-2.143v1.682m0 3.777h2.626c.467 0 .843-.377.843-.875 0-.494-.376-.87-.843-.87h-2.626V9.66m-2.706 2.127V2.212h5.629c1.618 0 2.928.944 2.928 2.424 0 1.173-.721 1.857-1.374 2.117 0 0-.042.01-.111.016.069.005.111.016.111.016 1.135.361 1.953 1.183 1.953 2.424 0 1.587-1.337 2.578-2.982 2.578h-6.154",
    mask: "url(#prefix__88d8afed-be18-45cd-8cc8-d3d3b418ed45)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeb);
export default __webpack_public_path__ + "static/media/seb.28ba1ef4.svg";
export { ForwardRef as ReactComponent };